export default __webpack_public_path__ + "static/media/0229.fed87737.jpg";